import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-361a97d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "buttons__container" }
const _hoisted_3 = { class: "launch__description" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "THE TERMINOLOGY…", -1))
const _hoisted_5 = { class: "img__container" }
const _hoisted_6 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(['btn', { active: _ctx.number === 0 }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.number = 0))
      }, " 1 ", 2),
      _createElementVNode("button", {
        class: _normalizeClass(['btn', { active: _ctx.number === 1 }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.number = 1))
      }, " 2 ", 2),
      _createElementVNode("button", {
        class: _normalizeClass(['btn', { active: _ctx.number === 2 }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.number = 2))
      }, " 3 ", 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("h2", null, _toDisplayString(_ctx.launchInformation[_ctx.number].subtitle), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.launchInformation[_ctx.number].paragraph), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("img", {
        src: _ctx.launchInformation[_ctx.number].src,
        alt: _ctx.launchInformation[_ctx.number].alt
      }, null, 8, _hoisted_6)
    ])
  ]))
}